'use strict';

define('TrackingPixelView', ['backbone', 'FieldView', 'parseUrl'],
  function (Backbone, FieldView, parseUrl) {
    var _ = Backbone._;
    var $ = Backbone.$;

    return FieldView.extend({
      __name__: 'TrackingPixelView',
      className: 'ngp-tracking-pixel',
      track: _.once(function () { // Only track this once
        var def = this.options.definition;
        var src = _.last(def.markup.match(/src=['"]?([^'" ]+)['"]?/));
        var qs = this.options.query_string;
        var ms = qs.ms || qs.track;
        // "ms" (our clients) or "track" (old Salsa clients)
        if (src) {
          var url = parseUrl(src);
          if (ms) {
            // Add MarketSource to the tracking pixel.
            if (_.last(url.pathname) !== '/') {
              url.pathname += '/';
            }
            // Limit it to 50 characters.
            url.pathname += ms.substring(0, 149);
            src = url.toString();
          }
          if ($('img[src="' + src + '"]').length === 0) {
            var pixel = new Image();
            pixel.src = src;
          }
        }
        return this;
      }),
      render: function () {
        return this.track();
      }
    });
  });

